import { TooltipContainer } from "@outplayed/tooltips";
import classNames from "classnames";
import React, { useMemo } from "react";
import { ReactComponent as TooltipIcon } from "svg/question-line.svg";

const BuildTabs = (props) => {
  const { activeTab, encounterType, onClick } = props;

  const tabOptions = useMemo(() => {
    if (encounterType === "raid") {
      return [
        { value: "single_target", label: "Single Target" },
        { value: "single_target_with_adds", label: "Single Target With Adds" },
        { value: "multi_target", label: "Cleave" },
      ];
    }
    if (encounterType === "mythic") {
      return [
        { value: "all_affixes", label: "Best M+ Build" },
        { value: "tyrannical", label: "Tyrannical" },
        { value: "fortified", label: "Fortified" },
      ];
    }
  }, [encounterType]);

  return (
    <div className="build-tabs-and-beta-tag">
      <div className="build-tabs-container">
        {tabOptions.map((option, index) => (
          <div
            className={classNames("build-tab", { active: activeTab === option.value })}
            onClick={() => onClick(option.value)}
            key={index}
          >
            {option.label}
          </div>
        ))}
      </div>
      <div className="beta-tag-container">
        <div className="beta-tag">BETA</div>
        <div className="label-text">Multi-Builds</div>
        <TooltipContainer tooltipInfo="We're testing out data-driven Multi-builds. The talent recommendations may not change between the three tabs, which means even at the highest levels of PVE content, players of this spec are not changing their talents based on encounter or affix.">
          <div className="question-mark">
            <TooltipIcon />
          </div>
        </TooltipContainer>
      </div>
    </div>
  );
};

export default BuildTabs;
